import React from "react";
import { CheckCircle2, Clock3, FileText } from "lucide-react";
import { getDocumentDate, getDocumentStatus } from "./documentHelpers";

const DocumentTimeline = ({ row = {}, config = {} }) => {
  const status = getDocumentStatus(row, config);

  const items = [
    {
      icon: FileText,
      title: `${config.singular || "Document"} created`,
      subtitle: getDocumentDate(row, config),
    },
    {
      icon: Clock3,
      title: `Current status: ${status.label}`,
      subtitle: "Synced from existing record data",
    },
    {
      icon: CheckCircle2,
      title: "Ready for next action",
      subtitle: "Use the actions above to continue the workflow",
    },
  ];

  return (
    <article className="document-timeline">
      <h3>Activity</h3>
      {items.map((item) => {
        const Icon = item.icon;
        return (
          <div className="document-timeline-item" key={item.title}>
            <span><Icon size={15} /></span>
            <div>
              <strong>{item.title}</strong>
              <small>{item.subtitle}</small>
            </div>
          </div>
        );
      })}
    </article>
  );
};

export default DocumentTimeline;
